import React from 'react';

import Link from 'depop/components/Link';

import { FormattedMessage } from 'react-intl';

const JobsLink = props =>
  <Link to={{ pathname: '/about/jobs/' }} {...props}>
    <FormattedMessage
      id="app.jobsLabel"
      description="Jobs Label"
      defaultMessage="Jobs"
    />
  </Link>;

export default JobsLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/JobsLink.js